import React, { Component } from 'react';
import { Query } from "react-apollo"
import gql from "graphql-tag"

import getGraphqlURI from 'utils/getGraphqlURI'
import RefetchOnLocaleChange from 'utils/RefetchOnLocaleChange'

export default (getLocale = props => props.match.params.language) => WrappedComponent => class WithQuery extends Component {
  render() {
    const locale = getLocale(this.props)

    return (
      <Query
        context={{
          uri: getGraphqlURI(locale)
        }}
        query={gql`
          query Redirects {
            optionsRedirects {
              redirects {
                from
                to
              }
            }
          }
        `}
      >
        {({ loading, error, data, refetch }) => (
          <div>
            {!error &&
              <RefetchOnLocaleChange locale={locale} refetch={refetch}>
                <WrappedComponent
                  {...this.props}
                  redirectsLoading={loading}
                  redirects={!loading && !error && data.optionsRedirects.redirects}
                />
              </RefetchOnLocaleChange>
            }
            {error && <h1>Error: {error.message}</h1>}
          </div>
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/withRedirects.js